import React, { Component } from "react";
import ReactDOM from "react-dom";

import bgDesktop from "../assets/images/final_background_desktop.png";
import bgMobile from "../assets/images/final_background_mobile.png";
import medalla_black from "../assets/images/medalla-letra-M_1.png";
import medalla_color from "../assets/images/medalla-letra-M_2.png";
import casi_lo_logras_1 from "../assets/images/casi_lo_logras_1.png";
import casi_lo_logras_2 from "../assets/images/casi_lo_logras_2.png";
import sigue_intentando_1 from "../assets/images/sigue_intentando_1.png";
import sigue_intentando_2 from "../assets/images/sigue_intentando_2.png";
import leiste_excelente_1 from "../assets/images/leiste_excelente_1.png";
import leiste_excelente_2 from "../assets/images/leiste_excelente_2.png";
import final_button from "../assets/images/volver_a_jugar.png";
import reflector from "../assets/images/leiste_excelente_luz.png";
import estrellas from "../assets/images/leiste_excelente_estrellas.png";
import musica2 from "../assets/sound/narracion/musica2.mp3";
import initAudio from "../assets/sound/narracion/INICIA JUEGO.mp3";
import finalAudio from "../assets/sound/narracion/FINAL NIÑOS.mp3";
import finalAudioPodios from "../assets/sound/narracion/PODIOS 2 y 3.mp3";
import click from "../assets/sound/fx/Click.mp3";

import Juego_1 from "./juegos/Juego_1";

const musics = [musica2];
// let music_index = Math.floor(Math.random() * (2 - 0) + 0);
const music = new Audio(musics[0]);
const init_audio = new Audio(initAudio);
const final_audio = new Audio(finalAudio);
const final_audio_podios = new Audio(finalAudioPodios);

class Fin extends Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      calification: 0,
    };
  }

  componentDidMount() {
      let low = 6
      let up = 9
      if (this.props.total === 15){
        low = 10
        up = 12
      }
      if (this.props.total === 20){
        low = 13
        up = 16
      }
    setTimeout(() => {
      if (this.props.puntos < low) {
        this.setState({ calification: 3 });
      } else if (this.props.puntos > up) {
        this.setState({ calification: 1 });
        this.props.final_audio.volume = 0.4;
        this.props.final_audio.play();
      } else {
        this.setState({ calification: 2 });
        this.props.final_audio_podios.play();
      }
    }, 200);
  }

  Repetir(value) {
    // ReactGA.event({
    //   category: "leB",
    //   action: "FfleB",
    // });

    let audio = new Audio(click);
    audio.play();

    music.play();
    music.pause();
    init_audio.play();
    init_audio.pause();
    final_audio.play();
    final_audio.pause();
    final_audio_podios.play();
    final_audio_podios.pause();

    setTimeout(function () {
      // let newValor = value;
      const element = (
        <Juego_1
          music={music}
          init_audio={init_audio}
          final_audio={final_audio}
          final_audio_podios={final_audio_podios}
        />
      );
      ReactDOM.render(element, document.getElementById("root"));
    }, 500);
  }

  render() {
    return (
      <div
        style={{
          backgroundColor: "#247BA0",
          position: "relative",
          width: "100%",
          height: "100%",
        }}
      >
        {(window.innerWidth > 480) &
        (window.innerWidth / window.innerHeight > 1) ? (
          <div>
            <img
              src={bgDesktop}
              className="final-background-image"
              alt="background"
            />{" "}
          </div>
        ) : (
          <div>
            <img
              src={bgMobile}
              className="final-background-image"
              alt="background"
            />{" "}
          </div>
        )}
        {this.state.calification === 1 ? (
          <div>
            <img src={medalla_color} className="medalla-image" alt="medalla" />
          </div>
        ) : (
          <div>
            <img src={medalla_black} className="medalla-image" alt="medalla" />
          </div>
        )}
        <div>
          <img
            src={final_button}
            className="final-button-image"
            onClick={this.Repetir}
            alt="volver a jugar"
          />
        </div>
        <div class="container-clasification">
          {this.state.calification === 3 ? (
            <div>
              <img
                src={sigue_intentando_2}
                className="clasification-image sigueIntentando"
                alt="Sigue intentando"
              />
              {/* <img
                src={reflector}
                style={{ left: "1%" }}
                className="reflector"
                alt="reflector"
              /> */}
            </div>
          ) : (
            <div>
              <img
                src={sigue_intentando_1}
                className="clasification-image sigueIntentando"
                alt="Sigue intentando"
              />
            </div>
          )}
          {this.state.calification === 2 ? (
            <div>
              <img
                src={casi_lo_logras_2}
                className="clasification-image casiLoLogras"
                alt="Casi lo logras"
              />
              {/* <img
                src={reflector}
                style={{ left: "33%" }}
                className="reflector"
                alt="reflector"
              /> */}
            </div>
          ) : (
            <div>
              <img
                src={casi_lo_logras_1}
                className="clasification-image casiLoLogras"
                alt="Casi lo logras"
              />
            </div>
          )}
          {this.state.calification === 1 ? (
            <div>
              <img
                src={leiste_excelente_2}
                className="clasification-image leisteExcelente"
                alt="Leiste excelente"
              />
              <img
                src={reflector}
                style={{ left: "67%" }}
                className="reflector"
                alt="reflector"
              />
              <img
                src={estrellas}
                style={{ left: "67%" }}
                className="reflector"
                alt="reflector"
              />
            </div>
          ) : (
            <div>
              <img
                src={leiste_excelente_1}
                className="clasification-image leisteExcelente"
                alt="Leiste excelente"
              />
            </div>
          )}
        </div>
      </div>
    );
  }
}

export default Fin;
